import React from "react";
import AppLayout from "../../layout";
import pen from "../../assets/coding.jpg";
import {
  DownloadOutlined,
  LinkedinFilled,
  TwitterOutlined,
  MailFilled,
} from "@ant-design/icons";
import { BrowserView, MobileOnlyView } from "react-device-detect";
import { Button } from "antd";
import { PresentationMobile } from "../mobile";

const Presentation = () => {
  return (
    <AppLayout>
      <BrowserView>
        <div className="presentation">
          <PreLeft />
          <PreRight />
        </div>
      </BrowserView>
      <MobileOnlyView>
        <PresentationMobile />
      </MobileOnlyView>
    </AppLayout>
  );
};

const PreLeft = () => {
  return (
    <div className="pre_left">
      <div className="text_left">
        <h5
          style={{
            letterSpacing: 7,
            fontSize: 24,
            lineHeight: 1,
            fontFamily: "serif",
          }}
        >
          SALUT, JE SUIS
        </h5>
        <h1 style={{ padding: 0, fontSize: 80 }}>Halimatou Diallo</h1>
        <p style={{ fontSize: 21, lineHeight: 1 }}>
          UX / UI DESIGN, DEVELOPPEUSE FRONT END
        </p>
      </div>
    </div>
  );
};

export const onButtonClick = () => {
  // using Java Script method to get PDF file
  fetch("halima-CV.pdf").then((response) => {
    response.blob().then((blob) => {
      // Creating new object of PDF file
      const fileURL = window.URL.createObjectURL(blob);
      // Setting various property values
      let alink = document.createElement("a");
      alink.href = fileURL;
      alink.download = "cv-halimatou.pdf";
      alink.click();
    });
  });
};

const PreRight = () => {
  return (
    <div className="pre_right">
      <div className="deco0"></div>
      {/* <div className="deco1"></div> */}
      <img src={pen} alt="imageProfil" />
      <h1>Halimatou Diallo</h1>

      <div className="job">
        <p className="p1">Développeuse Front End</p>
        <p>UX / UI Design</p>
      </div>

      <div
        className="contact"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <span>
          dialllohali2017@gmail.com
          <br />
        </span>
        <span>+221 78 139 22 17</span>
      </div>

      <div className="list-icons">
        <a
          href="https://www.linkedin.com/in/halimatou-diallo-a4302b221/"
          target="_brank"
        >
          <LinkedinFilled />
        </a>
        <a href="mailto:dialllohali2017@gmail.com">
          <MailFilled />
        </a>
        <a href="https://twitter.com/Indulgente14" target="_brank">
          <TwitterOutlined />
        </a>
      </div>
      <Button
        type="primary"
        icon={<DownloadOutlined />}
        size="large"
        onClick={onButtonClick}
      >
        Download CV
      </Button>
    </div>
  );
};

export default Presentation;
